import { render, staticRenderFns } from "./DisplayRate.vue?vue&type=template&id=70f7352e&lang=pug&"
import script from "./DisplayRate.vue?vue&type=script&lang=js&"
export * from "./DisplayRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports